import { Box, Typography } from "@mui/material";
import servicesImage from "../images/feature-image.png";

const HeroFeatureSection = () => {
  return (
    <Box
      sx={{
        py: { xs: "48px", md: "72px" },
        px: { xs: "24px", md: "80px" },
        maxWidth: "1152px",
        mx: "auto",
      }}
    >
      <Typography
        sx={{
          fontFamily: "Mulish",
          fontWeight: 700,
          fontSize: { xs: "40px", md: "56px" },
          color: "#614438",
          textAlign: "center",
        }}
      >
        We are here for you.
      </Typography>

      <Typography
        sx={{
          fontFamily: "Mulish",
          fontWeight: 400,
          fontSize: { xs: "15px", md: "17px" },
          color: "#737373",
          textAlign: "center",
          lineHeight: 1.7,
          mt: 1.5,
        }}
      >
        We offer comprehensive funeral services tailored to honor your loved
        <br />
        ones and support your family through this difficult time.
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: "28px",
        }}
      >
        <Box
          component="img"
          src={servicesImage}
          alt="services"
          sx={{ height: "400px", width: "1200px", maxWidth: "100%" }}
        />
      </Box>
    </Box>
  );
};

export default HeroFeatureSection;
